import { SchemaColumnOptions, SchemaTableOptions } from "@/vendors/prx-sqlite/Interfaces/SchemaInterfaces";

export const offices:SchemaTableOptions = {
    name:<string> 'offices',
    schema:<Array<SchemaColumnOptions>> [
        { column: 'id', value: 'INTEGER PRIMARY KEY AUTOINCREMENT'},
        { column: 'name', value: 'VARCHAR(255) NOT NULL'},
        { column: 'status', value: 'INTEGER UNSIGNED'},
        { column: 'region_id', value: 'INTEGER UNSIGNED'},
        { column: 'province_id', value: 'INTEGER UNSIGNED'},
        { column: 'city_id', value: 'INTEGER UNSIGNED'},
        { column: 'barangay_id', value: 'INTEGER UNSIGNED'},
    ]
}